"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.PictureInPictureManager = void 0;
class PictureInPictureManager {
    constructor(videoElement) {
        this.videoElement = videoElement;
    }
    static isSupported() {
        var _a;
        return (_a = document.pictureInPictureEnabled) !== null && _a !== void 0 ? _a : false;
    }
    isPictureInPicture() {
        return !!document.pictureInPictureElement;
    }
    isPictureInPictureAvailable() {
        return (this.videoElement.videoHeight !== 0 || this.videoElement.videoWidth !== 0);
    }
    requestPictureInPicture() {
        var _a, _b;
        if (!this.isPictureInPictureAvailable()) {
            return;
        }
        (_b = (_a = this.videoElement).requestPictureInPicture) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    exitPictureInPicture() {
        var _a;
        (_a = document.exitPictureInPicture) === null || _a === void 0 ? void 0 : _a.call(document);
    }
    togglePictureInPicture() {
        if (this.isPictureInPicture()) {
            this.exitPictureInPicture();
        }
        else {
            this.requestPictureInPicture();
        }
    }
    destroy() {
        if (this.isPictureInPicture()) {
            this.exitPictureInPicture();
        }
    }
}
exports.PictureInPictureManager = PictureInPictureManager;
//# sourceMappingURL=PictureInPictureManager.js.map